import React, { Component } from 'react';
import { components } from '../../geomoose';
import baseUrl from "../baseUrl";
//const IdentifyService = require("../../services/identify");
const SearchService = require("../../services/search");
const SelectService = require("../../services/select");
const ZoomService = require("../../services/zoomto");

const point_projections = [
    {
        label: 'Lat,Lon',
        ref: 'latlon'
    }
];
class MapComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    init() {
        const _ = this;
        this.props.app.loadMapbook({ url: `${baseUrl.public}xml/mapbook.xml` }).then((xml) => {
            this.props.app.setView({
                center: [-9392964.2, 5253134.8],
                zoom: 13
            });

            this.props.app.registerService('search', SearchService, {
                fields: [
                    { type: 'text', label: 'Parcel Number', name: 'parcelnum' },
                    { type: 'text', label: 'Owner Name', name: 'ownername' },
                    { type: 'text', label: 'House Number', name: 'propaddrnu' },
                    { type: 'text', label: 'Street Name', name: 'propstreet' },
                ],
                searchLayers: ['parcel_data_wfs/parcels']
            });
            this.props.app.registerService('select', SelectService, {
                searchLayers: ['parcel_data_wfs/parcels']
            });
            this.props.app.registerService('identify', SelectService, {
                searchLayers: ['parcel_data_wfs/parcels'],
                title: "Identify",
                tools: {
                    'Point': false,
                    'MultiPoint': false,
                    'Polygon': false,
                    'LineString': false,
                    'Select': false,
                    'Modify': false,
                    'default': 'Point',
                    'buffer': false
                },
                bufferAvailable: false,
                autoGo: true,
                keepAlive: true,
                name: "identify"
            });
            this.props.app.registerAction('fullextent', ZoomService, {
                extent: [-9417970.832865, 5224394.685108, -9366486.464156, 5278037.617856]
            });
            this.props.app.add(components.ServiceManager, 'tools-tab', {
                services: true,
                measureToolOptions: {
                    pointProjections: point_projections
                }
            });
            var print_preview = this.props.app.add(components.PrintModal, 'print-preview', {});
            this.props.app.registerAction('print', function() {
                this.run = function() {
                   print_preview.setState({open: true});
                   print_preview.forceUpdate();
                }
            }, {});
        
            this.props.app.add(components.Catalog, 'layers-tab');
            // this.props.app.add(components.CoordinateDisplay, 'coords');
            // this.props.app.add(components.Toolbar, 'toolbar');
            this.props.app.add(components.Map, 'map', {});
        })
    }
    componentDidMount() {
        this.init();
    }

    render() {
        return (
            <div className="map-component">                
                <div id="map"></div>
            </div>
        )
    }
}

export default MapComponent;